 import { Slot } from "./types";

export const now = () => new Date().toISOString();

export const format = (s: Slot) =>
  `${s.date} ${s.start}-${s.end}`;

export const addHour = (start: string) => {
  const [h, m] = start.split(":").map(Number);
  const d = new Date();
  d.setHours(h);
  d.setMinutes(m + 60);

  return `${d.getHours().toString().padStart(2, "0")}:${d
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
};

export const generateTimeOptions = (): string[] => {
  const options: string[] = [];
  let hour = 7;
  let minute = 0;

  while (hour < 20 || (hour === 20 && minute === 0)) {
    const h = hour.toString().padStart(2, "0");
    const m = minute.toString().padStart(2, "0");

    options.push(`${h}:${m}`);

    minute += 30;
    if (minute === 60) {
      minute = 0;
      hour++;
    }
  }

  return options;
};


